export function isMobileViewport() {
	return $(window).width < 991;
}
